module.exports = __webpack_public_path__ + "static/img/future.15d3b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/future.png
// module id = 59
// module chunks = 1 2 3